import styles from './index.module.less';
import { formatNumber, appPath } from '@web3/base-utils';
import BigNumber from 'bignumber.js';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { useFm } from '@web3/base-hooks';
import { CoinInfo } from '@/types/common';
import { useBbSolConfigContext } from '@/hooks/useBboSolInfo';
import { AirdropActivity } from '@/types/bbsol';

interface Props {
  stakeAmount: string;
  aprPreDayAmount: string;
  currentStakeToken: CoinInfo;
  stakeLpInfo: Partial<CoinInfo>;
  activity: AirdropActivity;
}

export const EarnArea = (props: Props) => {
  const {
    stakeAmount,
    stakeLpInfo,
    aprPreDayAmount,
    currentStakeToken,
    activity,
  } = props;
  const fm = useFm();
  const { solConfig } = useBbSolConfigContext();
  const { poolInfo } = usePoolInfoContext();
  const { lpCoin } = poolInfo || {};
  return (
    <>
      <div className={styles.swap}>
        <img
          src={`${appPath}/png/bybitsol/swapBtn.png`}
          alt=""
          className={styles.swapIcon}
        />
      </div>
      <div className={styles.earnTokenContainer}>
        <div className={styles.earnToken}>
          {solConfig?.airdropConfig?.length > 0 && !activity ? (
            <img
              src={`${appPath}/png/bybitsol/gift2.png`}
              alt=""
              className={styles.gift}
            />
          ) : null}

          <img
            src={
              solConfig?.airdropConfig?.length > 0
                ? `${appPath}/png/bybitsol/bbsolIcon.png`
                : lpCoin?.iconNightUrl
            }
            className={styles.earnTokenIcon}
          />
          <div className={styles.earnTokenSymbol}>{lpCoin?.symbol}</div>
        </div>
        <div className={styles.earnValueContainer}>
          <div className={styles.earnTokenAmount}>
            {stakeLpInfo?.amount && BigNumber(stakeAmount).gt(0)
              ? formatNumber(stakeLpInfo?.amount, {
                  kmb: true,
                  decimal: 4,
                  smallNumberUseValidDigits: false,
                  collapseZero: false,
                })
              : '0.00'}
          </div>
          {/* 每日收益 */}
          <div className={styles.earnEstimate}>
            {stakeAmount
              ? `${fm('estiDailyProfit')} ${formatNumber(aprPreDayAmount, {
                  kmb: true,
                  decimal: 4,
                  smallNumberUseValidDigits: false,
                  collapseZero: false,
                })} ${currentStakeToken?.symbol}`
              : `${fm('estiDailyProfit')} --`}
          </div>
        </div>
      </div>
    </>
  );
};
